import { Button, Dialog, DialogFooter, DialogType, FontWeights, getTheme, IButtonStyles, IconButton, IIconProps, IStackProps, mergeStyleSets, MessageBar, Modal, PrimaryButton, ProgressIndicator, Stack, TextField } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IInvoiceItem } from '../../../../Models/Invoice/IInvoiceItem';
import { IStatusMessage } from '../../../../Models/IStatusMessage';

interface IAddItemToInvoiceViewProps {
    item: IInvoiceItem;
    saveItem: (item: IInvoiceItem) => void;
    close: () => void;
    isVisible: boolean;
    isReadOnly: boolean;
    propertyChanged: (key: string, value: any) => void;
    isLoading: boolean;
    statusMessage?: IStatusMessage;
}


export const AddItemToInvoiceView: React.FunctionComponent<IAddItemToInvoiceViewProps> = (props) => {
    const theme = getTheme();

    const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
        },
        header: [
            theme.fonts.xLargePlus,
            {
                flex: '1 1 auto',
                borderTop: `4px solid ${theme.palette.themePrimary}`,
                color: theme.palette.neutralPrimary,
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 12px 14px 24px',
            },
        ],
        body: {
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 },
            },
        },
    });
    const stackProps: Partial<IStackProps> = {
        horizontal: true,
        tokens: { childrenGap: 40 },
        styles: { root: { marginBottom: 20 } },
    };
    const iconButtonStyles: Partial<IButtonStyles> = {
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: 'auto',
            marginTop: '4px',
            marginRight: '2px',
        },
        rootHovered: {
            color: theme.palette.neutralDark,
        },
    };
    const cancelIcon: IIconProps = { iconName: 'Cancel' };
    const titleId = useId('title');



    const textChanged = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event?.target) {
            var id = event.currentTarget.id;
            props.propertyChanged(id, newValue);
        }
    }

    return (<>{props.isVisible ?
        <Modal
            isOpen={props.isVisible}
            onDismiss={close}
            isBlocking={true}
        >
            <div className={contentStyles.header}>
                <span id={titleId}>{props.item.id === 0 ? "Přidání řádku na fakturu" : "Editace řádku na faktuře"}</span>
                <IconButton
                    styles={iconButtonStyles}
                    iconProps={cancelIcon}
                    ariaLabel="Close popup modal"
                    onClick={props.close}
                />
            </div>
            <div className={contentStyles.body}>
                <Stack tokens={{ childrenGap: 10 }} styles={{ root: { paddingBottom:20 } }}>
                    <Stack horizontal tokens={{ childrenGap: 10 }} >
                        <TextField key="itemId" id="itemId" label="Položka kod" styles={{ root: { width: 80 } }} value={props.item.itemId === 0 ? "" : props.item.itemId.toString()} onChange={textChanged} />
                        <TextField key="itemName" id="itemName" label="Položka název" styles={{ root: { width: 300 } }} value={props.item.itemName.toString()} onChange={textChanged} />
                    </Stack>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                        <TextField key="amount" id="amount" label="Množství" styles={{ root: { width: 80 } }} value={props.item.amount.toString()} onChange={textChanged} />
                        <TextField key="price" id="price" label="Cena/mj" styles={{ root: { width: 120 } }} value={props.item.price.toString()} onChange={textChanged} />
                        <TextField label="Celkem" styles={{ root: { width: 170 } }} value={(props.item.price * props.item.amount).toString()} />
                    </Stack>
                </Stack>
                <Stack styles={{ root: { minHeight: 20 } }}>
                    {props.isLoading ? <ProgressIndicator /> : null}
                    {props.statusMessage ? <MessageBar messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar> : null}
                </Stack>
                <DialogFooter>
                    <PrimaryButton onClick={() => props.saveItem(props.item)} text="Uložit" />
                    <Button text="Zavřít" onClick={props.close} />
                </DialogFooter>
            </div>

           
    </Modal> : null
    }</>)
}
